module.exports = __webpack_public_path__ + "static/img/xd.853e9bda.svg";